export class BiasesCarousel {
  constructor(options) {
    this.view = options.view.make(options.selector, options.biases);
    this.biases = options.biases;
    this.bias = options.slug
      ? this.biases.get(options.slug)
      : this.biases.first();

    this.elements = {
      buttons: document.querySelectorAll(`${options.selector} .square-button`),
      next: document.querySelector(`${options.selector} .next-bias`),
      prev: document.querySelector(`${options.selector} .prev-bias`)
    };

    this.view.bindEvents(this);

    if (options.autostart) {
      this.start();
    }
  }

  go(direction = 'next') {
    direction === 'prev'
      ? this.prev(true)
      : this.next(true);

    appHistory.maskHistory(this.bias.slug, this.bias.title);
    this.stop();
  }

  start() {
    if (this.interval) {
      clearInterval(this.interval);
    } else {
      this.load(0);
    }

    this.interval = setInterval(() => {
      this.next();
    }, 6000);
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  reset() {
    this.start();
  }

  index() {
    return this.biases.indexOf(this.bias);
  }

  next(advanced = false) {
    if (this.index() === this.biases.lastIndexOf()) {
      return this.load(0);
    }

    return this.load(this.index() + 1, advanced);
  }

  prev(advanced = false) {
    if (this.index() === 0) {
      return this.load(this.biases.lastIndexOf());
    }

    return this.load(this.index() - 1, advanced);
  }

  jumpToIndex(index) {
    this.load(index);
    this.reset();
  }

  navigateToIndex(index) {
    this.stop();
    this.view.navigate(this.biases.get(index));
  }

  load(index, advanced) {
    this.bias = this.biases.get(index);
    this.view.load(this.bias, advanced);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/carousel/BiasesCarousel.js